"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chars = void 0;
exports.chars = (value) => value.split("");
//# sourceMappingURL=chars.js.map